// extracted by mini-css-extract-plugin
export default {"input":"LoginForm_input_GILRv","button":"LoginForm_button_gjvCo"};